<template>
<svg :width="w" :height="h" :viewBox="wb">
  <g :transform="rot" stroke="#555">
    <ellipse :cx="mid" :cy="mid" :rx="r" :ry="r" fill="none" stroke-linejoin="round" :stroke-width="str" />
    <path :d="d" stroke-width=".7958" />
  </g>
</svg>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'

const props = defineProps(['wdir'])

const w = ref(90)
const h = ref(w.value)
const wb = ref('0 0 ' + w.value + ' ' + h.value)
const mid = ref(w.value / 2)
const d = ref('m'+.25*w.value+' '+.15*h.value+' '+.25*w.value+' '+.77*h.value+' '+.25*w.value+' -'+.77*h.value+' -'+.25*w.value+' '+.15*h.value+'z')
const rot = ref('rotate('+props.wdir+', '+mid.value+', '+mid.value+')')
const str = ref(w.value * .01)
const r = ref((w.value / 2) - (2 * str.value))

watch(props, (newProps) => {
  rot.value = 'rotate('+newProps.wdir+', '+mid.value+', '+mid.value+')'
})

</script>
